import React from "react";
import RailServicePage from "./RailServicePage";

export default function TrainSchedules() {
  return (
    <RailServicePage
      eyebrow="Train Schedules"
      title="Check train schedules and route options"
      description="Plan around departure times, arrival windows, station choices, and direct train options before you book."
      icon="schedules"
      highlights={[
        {
          title: "Departure planning",
          text: "Compare morning, afternoon, and evening rail options for your route.",
        },
        {
          title: "Station guidance",
          text: "Get help choosing the right city station and understanding route timing before travel day.",
        },
      ]}
      steps={[
        "Enter the stations or cities you want to travel between.",
        "Choose your date and passenger count.",
        "Review schedule options and call for live guidance.",
      ]}
    />
  );
}
